// extracted by mini-css-extract-plugin
module.exports = {"detail":"Detail_detail__2gy9I","loading":"Detail_loading__1OKFz","error":"Detail_error__1-I5V"};